import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { MomentRecipientsClassify } from "../../../../../../hooks/use-moment-recipients-classify";
import { GreyBox } from "../../components/grey-box";

export const PreviewWithSidebarChannel: FC<{
  data: Extract<MomentRecipientsClassify, { type: "channel" }>["data"];
}> = ({ data }) => {
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="body2">
        {data.channel_name ? `Message to #${data.channel_name}` : "Not Set"}
      </Typography>
      <GreyBox>
        <Typography variant="body2" color="textSecondary">
          We can’t show previews for merge tags in channel messages unless they are based on an
          automated event.
        </Typography>
      </GreyBox>
    </Stack>
  );
};
